import { useState } from 'react';

interface ReportModalProps {
  type: 'report' | 'block';
  onConfirm: (reason?: string) => void;
  onClose: () => void;
}

const reportReasons = [
  'Uygunsuz içerik / müstehcenlik',
  'Taciz veya zorbalık',
  'Nefret söylemi',
  'Spam veya reklam',
  'Küçük yaşta görünüyor (18 altı)',
  'Sahte kimlik / dolandırıcılık',
  'Diğer',
];

const ReportModal = ({ type, onConfirm, onClose }: ReportModalProps) => {
  const [selected, setSelected] = useState('');

  const isReport = type === 'report';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative w-full max-w-md bg-[#0d1117] border border-white/10 rounded-3xl overflow-hidden shadow-2xl">
        {/* Header */}
        <div className={`px-6 py-5 border-b border-white/8 flex items-center gap-3 ${isReport ? 'bg-orange-500/5' : 'bg-red-500/5'}`}>
          <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${isReport ? 'bg-orange-500/20 text-orange-400' : 'bg-red-500/20 text-red-400'}`}>
            <i className={`${isReport ? 'ri-alarm-warning-line' : 'ri-user-forbid-line'} text-xl`} />
          </div>
          <div>
            <h3 className="text-white font-bold text-base">
              {isReport ? 'Kullanıcıyı Raporla' : 'Kullanıcıyı Engelle'}
            </h3>
            <p className="text-white/40 text-xs mt-0.5">
              {isReport ? 'Uygunsuz davranışı bizimle paylaş' : 'Bu kullanıcı bir daha karşına çıkmayacak'}
            </p>
          </div>
          <button
            onClick={onClose}
            className="ml-auto w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 text-white/40 hover:text-white transition-all cursor-pointer"
          >
            <i className="ri-close-line" />
          </button>
        </div>

        <div className="px-6 py-5">
          {isReport ? (
            <>
              <p className="text-white/50 text-sm mb-4">Neden raporluyorsunuz?</p>
              <div className="flex flex-col gap-2 mb-6">
                {reportReasons.map((reason) => (
                  <label
                    key={reason}
                    className={`flex items-center gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-all ${
                      selected === reason
                        ? 'border-orange-500/40 bg-orange-500/10 text-white'
                        : 'border-white/8 bg-white/3 text-white/60 hover:border-white/15 hover:text-white/80'
                    }`}
                  >
                    <div
                      className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${
                        selected === reason ? 'border-orange-400 bg-orange-400' : 'border-white/20'
                      }`}
                    >
                      {selected === reason && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
                    </div>
                    <span className="text-sm">{reason}</span>
                  </label>
                ))}
              </div>
              <div className="flex gap-3">
                <button
                  onClick={onClose}
                  className="flex-1 py-3 rounded-full bg-white/5 border border-white/10 text-white/60 text-sm font-medium hover:bg-white/8 hover:text-white transition-all cursor-pointer whitespace-nowrap"
                >
                  İptal
                </button>
                <button
                  onClick={() => onConfirm(selected)}
                  disabled={!selected}
                  className="flex-1 py-3 rounded-full bg-gradient-to-r from-orange-500 to-red-500 text-white text-sm font-bold hover:from-orange-400 hover:to-red-400 transition-all cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
                >
                  Raporla
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="flex flex-col items-center text-center py-4 mb-6">
                <div className="w-16 h-16 rounded-full bg-red-500/15 border border-red-500/25 flex items-center justify-center mb-4">
                  <i className="ri-user-forbid-line text-red-400 text-3xl" />
                </div>
                <p className="text-white/70 text-sm leading-relaxed max-w-xs">
                  Bu kullanıcı engellendi. Bir daha hiçbir zaman sana eşleşmeyecek.
                  Bu işlem geri alınamaz.
                </p>
              </div>
              <div className="flex gap-3">
                <button
                  onClick={onClose}
                  className="flex-1 py-3 rounded-full bg-white/5 border border-white/10 text-white/60 text-sm font-medium hover:bg-white/8 hover:text-white transition-all cursor-pointer whitespace-nowrap"
                >
                  İptal
                </button>
                <button
                  onClick={() => onConfirm()}
                  className="flex-1 py-3 rounded-full bg-red-500 text-white text-sm font-bold hover:bg-red-400 transition-all cursor-pointer whitespace-nowrap"
                >
                  Engelle ve Atla
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
